import { render, staticRenderFns } from "./LUMGroupSetting.vue?vue&type=template&id=64e6218e&"
import script from "./LUMGroupSetting.vue?vue&type=script&lang=js&"
export * from "./LUMGroupSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64e6218e')) {
      api.createRecord('64e6218e', component.options)
    } else {
      api.reload('64e6218e', component.options)
    }
    module.hot.accept("./LUMGroupSetting.vue?vue&type=template&id=64e6218e&", function () {
      api.rerender('64e6218e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckydraw/components/LUMGroupSetting.vue"
export default component.exports